<div id="history-container">
  <div id="content-container">
    <!-- <h1 id="title" *ngIf="ls.currentLanguage.HISTORY_HEADER"> -->
    <h1 class="card-header" *ngIf="this.ls.historyHeader">
      {{ this.ls.historyHeader | translatedb | uppercase }}
    </h1>
    <div id="content" *ngIf="this.ls.historyArticle"
         [innerHTML]="this.ls.historyArticle | translatedb"></div>
  </div>
</div>
